import React, { useEffect, useState } from "react";
import XLSX from "xlsx";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSpinner, faFilter, faColumns, faPlus, faTimes, faMoon, faSun } from "@fortawesome/free-solid-svg-icons";
import { components } from "react-select";
import { default as ReactSelect } from "react-select";
import DatePickerCustom from "./DatePicker";
import dayjs from "dayjs";
import { useAuth } from "../services/auth.service";
import axios from "axios";

export default function Automatizacion() {
  const [polizas, setPolizas] = useState([]);
  const [polizasFiltered, setPolizasFiltered] = useState([]);
  const [templateSent, setTemplateSent] = useState([]);
  const [aseguradoras, setAseguradoras] = useState([]);
  const [sucursales, setSucursales] = useState([]);
  const [statuses, setStatuses] = useState([]);
  const [currentMessageStatuses, setCurrentMessageStatuses] = useState([]);
  const [mensajesStatus, setMensajesStatus] = useState([]);
  const [ramos, setRamos] = useState([]);
  const [tipos, setTipos] = useState([]);
  const [checkedItems, setCheckedItems] = useState([]);
  const [templates, setTemplates] = useState([]);
  const [selectedTemplate, setSelectedTemplate] = useState(null);
  const [sentItems, setSentItems] = useState(0);
  const [modalMessageBody, setModalMessageBody] = useState("");
  const [modalStep, setModalStep] = useState("confirm");
  const [previewMessage, setPreviewMessage] = useState(null);
  const [variableOverrides, setVariableOverrides] = useState({});
  const [customTestPhone, setCustomTestPhone] = useState("");
  const [testSendStatus, setTestSendStatus] = useState("");
  const [selectedDate, setSelectedDate] = useState(dayjs().format("YYYY-MM"));
  const { user } = useAuth();
  const [columnsModalOpen, setColumnsModalOpen] = useState(false);
  const [availableColumns, setAvailableColumns] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [activeFilterColumns, setActiveFilterColumns] = useState([]);
  const [columnFilters, setColumnFilters] = useState({});
  const [isDarkMode, setIsDarkMode] = useState(false);

  const [selectedTipoRenovacion, setSelectedTipoRenovacion] = useState({ id: 1, name: "Por Vencer" });

  const [filterAutomation, setFilterAutomation] = useState({
    filtros: [],
    plantilla: "",
    hora: 0,
    minute: 0,
    dia: 0,
    monthDiff: 0,
    yearDiff: 0,
    month_query: dayjs().format("MM"),
    year_query: dayjs().format("YYYY"),
    tipo_renovacion: 1,
  });

  const [automationFilterTipo, setAutomationFilterTipo] = useState("");
  const [automationFilterValor, setAutomationFilterValor] = useState("");

  const TipoRenovacionList = [
    { id: 1, name: "Por Vencer" },
    { id: 2, name: "Vencidas" },
  ];

  const automationFilterTipoOptions = [
    { value: "Aseguradora", label: "Aseguradora" },
    { value: "Sucursal", label: "Sucursal" },
    { value: "Ramo", label: "Ramo" },
    { value: "Estatus", label: "Estatus" },
    { value: "Tipo_Renovacion", label: "Tipo Renovacion" },
    { value: "Templates_Sent", label: "Plantilla" },
    { value: "currentMessageStatus", label: "Estatus Mensaje" },
  ];

  const preferredColumnOrder = [
    "Asegurado",
    "Templates_Sent",
    "currentMessageStatus",
    "newMessages",
    "chat",
    "Cedula",
    "Aseguradora",
    "Sucursal",
    "Nro_Poliza",
    "Ramo",
    "Estatus",
    "Tipo_Renovacion",
    "Vencimiento",
    "Saldo",
  ];
  const [selectedVisibleColumns, setSelectedVisibleColumns] = useState(preferredColumnOrder);
  const columnLabelMap = {
    Templates_Sent: "Plantilla",
    currentMessageStatus: "Estatus Mensaje",
    newMessages: "Cliente Resp",
    chat: "Chat",
    Nro_Poliza: "Nro Poliza",
    Tipo_Renovacion: "Tipo Renovacion",
    Vencimiento: "Venc",
  };
  const topControlClassName =
    isDarkMode
      ? "text-sm text-[#d1d5db] border border-[#2b313d] rounded-lg bg-[#0f1115] px-3 py-2 focus:ring-2 focus:ring-[#3b82f6] focus:border-[#3b82f6]"
      : "text-sm text-gray-700 border border-gray-300 rounded-lg bg-white px-3 py-2 focus:ring-2 focus:ring-blue-500 focus:border-blue-500";
  const reactSelectFilterStyles = {
    control: (base) => ({
      ...base,
      minHeight: "36px",
      borderColor: isDarkMode ? "#2b313d" : "#d1d5db",
      boxShadow: "none",
      borderRadius: "0.375rem",
      backgroundColor: isDarkMode ? "#0f1115" : "#ffffff",
      color: isDarkMode ? "#d1d5db" : "#374151",
    }),
    singleValue: (base) => ({ ...base, color: isDarkMode ? "#d1d5db" : "#374151" }),
    input: (base) => ({ ...base, color: isDarkMode ? "#d1d5db" : "#374151" }),
    placeholder: (base) => ({ ...base, color: isDarkMode ? "#94a3b8" : "#6b7280" }),
    multiValue: (base) => ({ ...base, backgroundColor: isDarkMode ? "#1f2430" : "#f3f4f6" }),
    multiValueLabel: (base) => ({ ...base, color: isDarkMode ? "#cbd5e1" : "#374151" }),
    valueContainer: (base) => ({
      ...base,
      padding: "0 8px",
    }),
    indicatorSeparator: () => ({
      display: "none",
    }),
    menuList: (base) => ({ ...base, backgroundColor: isDarkMode ? "#111827" : "#ffffff" }),
    option: (base, state) => ({
      ...base,
      backgroundColor: state.isFocused
        ? (isDarkMode ? "#1f2937" : "#f3f4f6")
        : (isDarkMode ? "#111827" : "#ffffff"),
      color: isDarkMode ? "#d1d5db" : "#374151",
    }),
    menu: (base) => ({
      ...base,
      zIndex: 30,
      backgroundColor: isDarkMode ? "#111827" : "#ffffff",
    }),
  };

  useEffect(() => {
    let templatesSents = [
      ...new Set(templates.map((template) => template.name)),
    ];
    setTemplateSent(templatesSents);
    let aseguradorasList = [
      ...new Set(polizas.map((poliza) => poliza.Aseguradora)),
    ];
    setAseguradoras(aseguradorasList);
    let statusesList = [...new Set(polizas.map((poliza) => poliza.Estatus))];
    setStatuses(statusesList);
    let tiposList = [...new Set(polizas.map((poliza) => poliza.Tipo_Renovacion))];
    setTipos(tiposList);
    let ramosList = [...new Set(polizas.map((poliza) => poliza.Ramo))];
    setRamos(ramosList);
    let sucursalesList = [...new Set(polizas.map((poliza) => poliza.Sucursal))];
    setSucursales(sucursalesList);
    let MensajesStatus = [
      ...new Set(polizas.map((poliza) => poliza.Mensaje_Status)),
    ];
    setMensajesStatus(MensajesStatus);
    let currentMessageStatusesList = [
      ...new Set(polizas.map((poliza) => poliza.currentMessageStatus)),
    ];
    setCurrentMessageStatuses(currentMessageStatusesList);

    setPolizasFiltered(polizas);

    const endpointColumns = Array.from(
      new Set(
        polizas
          .slice(0, 100)
          .flatMap((poliza) => Object.keys(poliza || {}))
      )
    );
    const mergedColumns = Array.from(
      new Set([...preferredColumnOrder, ...endpointColumns])
    );
    const sortedColumns = mergedColumns.sort((a, b) => {
      const indexA = preferredColumnOrder.indexOf(a);
      const indexB = preferredColumnOrder.indexOf(b);
      if (indexA === -1 && indexB === -1) return a.localeCompare(b);
      if (indexA === -1) return 1;
      if (indexB === -1) return -1;
      return indexA - indexB;
    });
    setAvailableColumns(sortedColumns);
    setSelectedVisibleColumns((prev) => {
      if (!prev?.length) return sortedColumns;
      const stillAvailable = prev.filter((column) => sortedColumns.includes(column));
      return stillAvailable.length ? stillAvailable : sortedColumns;
    });
  }, [polizas]);

  useEffect(() => {
    if (user) {
      const month = selectedDate.split("-")[1];
      const year = selectedDate.split("-")[0];
      setFilterAutomation((prev) => ({
        ...prev,
        month_query: month,
        year_query: year,
        tipo_renovacion: selectedTipoRenovacion.id,
      }));
      fetch(
        `${process.env.REACT_APP_BACKEND_API}/renovaciones/polizas?Mes=${month}&Ano=${year}&TipoRenovacion=${selectedTipoRenovacion.id}${user.roles[0] == 'ROLE_ADMIN' ? '' : '&SoloActivas=1'}`,
        {
          headers: {
            "Content-Type": "application/json",
            "x-access-token": user.accessToken,
          },
        }
      )
        .then((response) => response.json())
        .then((data) => {
          const polizasResponse = Array.isArray(data)
            ? data
            : Array.isArray(data?.polizas)
              ? data.polizas
              : [];
          if (user.roles[0] == 'ROLE_ADMIN') {
            setPolizas(polizasResponse);
          } else {
            setPolizas(polizasResponse.filter((poliza) => poliza.Estatus == 'ACTIVA'));
          }
        });
    }

    async function loadTemplates() {
      const url = process.env.REACT_APP_BACKEND_API + "/template";
      const config = {
        headers: {
          "x-access-token": user.accessToken,
          "Content-Type": "application/json",
        },
      };
      let result = await axios
        .get(url, config)
        .then((response) => response)
        .catch((error) => error);
      if (result.data) setTemplates(result.data);
    }
    loadTemplates();
  }, [selectedDate, selectedTipoRenovacion]);

  const handleDayChange = (event) => {
    const dayValue = Number(event.target.value || 0);
    setFilterAutomation((prev) => ({ ...prev, dia: dayValue }));
  };

  const handleHourChange = (event) => {
    const hourValue = Number(event.target.value || 0);
    const normalizedHour = Math.min(23, Math.max(0, hourValue));
    setFilterAutomation((prev) => ({ ...prev, hora: normalizedHour }));
  };

  const handleMinuteChange = (event) => {
    const minuteValue = Number(event.target.value || 0);
    const normalizedMinute = Math.min(59, Math.max(0, minuteValue));
    setFilterAutomation((prev) => ({ ...prev, minute: normalizedMinute }));
  };

  const handleDateChange = (date) => {
    setPolizasFiltered([]);
    let year = date.$y;
    let month = date.$M + 1 < 10 ? `0${date.$M + 1}` : date.$M + 1;
    setSelectedDate(`${year}-${month}`);
    let currentYear = parseInt(dayjs().format("YYYY"), 10);
    let currentMonth = parseInt(dayjs().format("MM"), 10);
    let yearDiff = year - currentYear;
    let monthDiff = parseInt(month, 10) - currentMonth;
    setFilterAutomation((prev) => ({
      ...prev,
      monthDiff,
      yearDiff,
      month_query: `${month}`,
      year_query: `${year}`,
    }));
  };

  const SelectCheckOptions = (props) => {
    return (
      <div>
        <components.Option {...props}>
          <input
            type="checkbox"
            checked={props.isSelected}
            onChange={() => null}
          />{" "}
          <label>{props.label}</label>
        </components.Option>
      </div>
    );
  };

  const splitURL = (url) => {
    let encoded = "";
    try {
      const split = url.split("/");
      const filename = split[split.length - 1];
      encoded = encodeURIComponent(filename);
    } catch (error) {
      encoded = "noexiste.PNG";
    }
    return encoded;
  };

  const getTemplateVariableCount = (template) => {
    if (!template) return 0;
    const bodyMatches = [...(template.body || "").matchAll(/\{\{(\d+)\}\}/g)].map((m) => Number(m[1]));
    const maxBodyIndex = bodyMatches.length ? Math.max(...bodyMatches) : 0;
    const parameterCount = Array.isArray(template.parameters) ? template.parameters.length : 0;
    return Math.max(maxBodyIndex, parameterCount);
  };

  const getParameterValuesForPoliza = (template, poliza, overrides = {}) => {
    const normalizedCompositeVariables = Array.isArray(template?.compositeVariables)
      ? template.compositeVariables
          .map((item) => ({
            name: `${item?.name || ""}`.trim(),
            expression: `${item?.expression || ""}`.trim(),
          }))
          .filter((item) => item.name && item.expression)
      : [];
    const compositeVariableMap = normalizedCompositeVariables.reduce((acc, item) => {
      acc[item.name] = item.expression;
      return acc;
    }, {});
    const resolveCompositeValue = (expression) =>
      `${expression || ""}`.replace(/\{([^}]+)\}/g, (_, fieldName) => {
        const key = `${fieldName}`.trim();
        return `${poliza?.[key] ?? ""}`;
      });

    const totalVariables = getTemplateVariableCount(template);
    const values = Array.from({ length: totalVariables }, (_, index) => {
      const overrideValue = overrides[index + 1];
      if (overrideValue !== undefined && `${overrideValue}`.trim() !== "") {
        return `${overrideValue}`;
      }
      const fieldName = template?.parameters?.[index]?.value;
      if (!fieldName) return "";
      if (compositeVariableMap[fieldName]) {
        return resolveCompositeValue(compositeVariableMap[fieldName]);
      }
      return poliza?.[fieldName] ?? "";
    });

    const comparisonRules = Array.isArray(template?.comparacionValores)
      ? template.comparacionValores
      : [];
    comparisonRules.forEach((rule) => {
      const sourceIndex = Number(rule?.variableOrigen || 0) - 1;
      const targetIndex = Number(rule?.variableDestino || 0) - 1;
      const compareField = `${rule?.campoComparacionEjecutivo || ""}`.trim();
      const resultField = `${rule?.campoResultadoEjecutivo || ""}`.trim();
      if (sourceIndex < 0 || targetIndex < 0 || !compareField || !resultField) return;
      const sourceValue = values[sourceIndex];
      if (sourceValue === undefined || sourceValue === null || `${sourceValue}`.trim() === "") return;

      const match = ejecutivos.find((ejecutivo) => {
        const ejecutivoValue = ejecutivo?.[compareField];
        if (ejecutivoValue === undefined || ejecutivoValue === null) return false;
        return `${ejecutivoValue}`.trim().toLowerCase() === `${sourceValue}`.trim().toLowerCase();
      });
      if (!match) return;
      const replacement = match?.[resultField];
      if (replacement === undefined || replacement === null || `${replacement}`.trim() === "") return;
      values[targetIndex] = `${replacement}`;
    });

    return values;
  };

  const getTemplateVariableValue = (values, variableNumber) => {
    const index = Number(variableNumber || 0) - 1;
    if (index < 0) return "";
    return `${values[index] ?? ""}`.trim();
  };

  const buildContactAssignmentPayload = (template, poliza, resolvedValues) => {
    const assignment = template?.asignacionEjecutivo || {};
    const ejecutivoName = getTemplateVariableValue(resolvedValues, assignment.variableEjecutivoNombre);
    const ejecutivoIdField = `${assignment?.campoEjecutivoId || ""}`.trim();
    const fallbackEjecutivoId = `${assignment?.fallbackEjecutivoId || ""}`.trim();
    const nombreClienteFromVar = getTemplateVariableValue(resolvedValues, assignment.variableNombreCliente);
    const nombreCliente = nombreClienteFromVar || poliza?.Asegurado || "";

    const normalizeText = (value) => `${value ?? ""}`.trim().toLowerCase();
    const matchedEjecutivo = ejecutivos.find((ejecutivo) => {
      if (!ejecutivoName) return false;
      const fullName = `${ejecutivo?.firstName || ""} ${ejecutivo?.lastName || ""}`.trim();
      return (
        normalizeText(ejecutivo?.firstName) === normalizeText(ejecutivoName) ||
        normalizeText(ejecutivo?.lastName) === normalizeText(ejecutivoName) ||
        normalizeText(fullName) === normalizeText(ejecutivoName) ||
        normalizeText(ejecutivo?.name) === normalizeText(ejecutivoName)
      );
    });
    const fallbackEjecutivoFromTemplate = fallbackEjecutivoId
      ? ejecutivos.find((ejecutivo) => `${ejecutivo?._id || ""}`.trim() === fallbackEjecutivoId)
      : null;
    const fallbackEjecutivo = fallbackEjecutivoFromTemplate || selectedEjecutivo || null;
    const ejecutivoSource = matchedEjecutivo || fallbackEjecutivo;
    const ejecutivoId = ejecutivoIdField && ejecutivoSource ? `${ejecutivoSource[ejecutivoIdField] ?? ""}`.trim() : "";
    const finalEjecutivoName = matchedEjecutivo
      ? ejecutivoName
      : `${ejecutivoSource?.firstName || ""} ${ejecutivoSource?.lastName || ""}`.trim() || ejecutivoName;

    const hasExecutiveAssignment = finalEjecutivoName && ejecutivoId;
    return {
      wa_id: poliza?.Celular || "",
      NombreCompleto: nombreCliente,
      notas: "",
      etiquetas: [],
      ejecutivoAsignado: hasExecutiveAssignment
        ? [{ value: ejecutivoId, label: finalEjecutivoName, selected: false }]
        : [],
      sucursalChat: [],
      _preview: {
        ejecutivoName: finalEjecutivoName,
        ejecutivoId,
        ejecutivoIdField,
        fallbackEjecutivoId,
        nombreCliente,
      },
    };
  };

  const updateContactAssignment = async (poliza, template, resolvedValues) => {
    if (!poliza?.Celular) return;
    const payload = buildContactAssignmentPayload(template, poliza, resolvedValues);
    await fetch(`${process.env.REACT_APP_BACKEND_API}/contacts/${poliza.Celular}`, {
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
        "x-access-token": user.accessToken,
      },
      body: JSON.stringify({
        wa_id: payload.wa_id,
        NombreCompleto: payload.NombreCompleto,
        notas: payload.notas,
        etiquetas: payload.etiquetas,
        ejecutivoAsignado: payload.ejecutivoAsignado,
        sucursalChat: payload.sucursalChat,
      }),
    }).catch(() => null);
  };

  const prepareCreateAutomation = (e) => {
    e?.preventDefault?.();
    if (!selectedTemplate) {
      alert("Seleccione una plantilla antes de crear la automatización");
      return;
    }
    const samplePoliza =
      polizas.find((poliza) => poliza._id == checkedItems[0]) ||
      polizasFiltered[0] ||
      polizas[0];
    if (!samplePoliza) {
      alert("No hay pólizas disponibles para previsualizar la automatización");
      return;
    }

    const previewParams = getParameterValuesForPoliza(selectedTemplate, samplePoliza, {});
    let previewBody = selectedTemplate.body || "";
    previewBody = previewBody.replace(/\{\{(\d+)\}\}/g, (_, index) => {
      const value = previewParams[Number(index) - 1];
      return value ?? `{{${index}}}`;
    });

    setPreviewMessage({
      to: samplePoliza.Celular,
      body: previewBody,
      image: selectedTemplate.image,
      asegurado: samplePoliza.Asegurado,
      total: filterAutomation.filtros.length || polizasFiltered.length,
    });
    setModalStep("confirm");
    setModalMessageBody("");
    setSentItems(0);
    setVariableOverrides({});
    setCustomTestPhone(samplePoliza.Celular || "");
    setTestSendStatus("");
    openModal();
  };

  const sendTestTemplateMessage = async () => {
    if (!selectedTemplate || !customTestPhone.trim()) return;
    const samplePoliza =
      polizas.find((poliza) => poliza._id == checkedItems[0]) ||
      polizasFiltered[0] ||
      polizas[0];
    if (!samplePoliza) return;
    setTestSendStatus("Enviando prueba...");

    const resolvedValues = getParameterValuesForPoliza(selectedTemplate, samplePoliza, variableOverrides);
    await updateContactAssignment(samplePoliza, selectedTemplate, resolvedValues);

    const payloadBase = {
      templateID: selectedTemplate.name,
      to: customTestPhone.trim(),
      parameters: resolvedValues.map((value) => ({
        type: "text",
        value,
      })),
      header: {
        image: selectedTemplate.image,
      },
      buttonParametersIndex: selectedTemplate.buttonparameterindex,
    };

    const buttonParameters =
      selectedTemplate.buttonparameters && selectedTemplate.buttonparameters.length > 0
        ? selectedTemplate.buttonparameters.map((buttonParameter) => {
          if (selectedTemplate.type === "quickreply") {
            return {
              type: "payload",
              value: buttonParameter.value,
            };
          }
          return {
            type: "text",
            value:
              buttonParameter.value == "DocumentoPoliza"
                ? splitURL(samplePoliza[buttonParameter.value])
                : samplePoliza[buttonParameter.value],
          };
        })
        : [];

    const body =
      selectedTemplate.type !== "quickreply"
        ? JSON.stringify({
          ...payloadBase,
          buttonParameters,
        })
        : JSON.stringify({
          ...payloadBase,
          quickReplies: true,
          dataId: samplePoliza._id,
          buttonParameters,
        });

    const result = await fetch(`${process.env.REACT_APP_BACKEND_API}/messages/sendtemplatemessage`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "x-access-token": user.accessToken,
      },
      body,
    })
      .then((response) => response.json())
      .catch(() => null);

    if (!result || result.error) {
      setTestSendStatus(result?.error?.message || "No se pudo enviar mensaje de prueba");
      return;
    }
    setTestSendStatus("Mensaje de prueba enviado");
  };

  const getCleanVariableOverrides = () =>
    Object.entries(variableOverrides || {}).reduce((acc, [key, value]) => {
      const normalizedValue = `${value ?? ""}`.trim();
      if (normalizedValue !== "") acc[key] = normalizedValue;
      return acc;
    }, {});

  const confirmCreateAutomation = () => {
    if (!selectedTemplate) return;
    const cleanVariableOverrides = getCleanVariableOverrides();
    setModalStep("sending");
    setModalMessageBody("Creando automatización...");
    setSentItems(50);

    fetch(
      `${process.env.REACT_APP_BACKEND_API}/renovaciones/crear_automatizacion`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "x-access-token": user.accessToken,
        },
        body: JSON.stringify({
          ...filterAutomation,
          variableOverrides: cleanVariableOverrides,
        }),
      }
    )
      .then((response) => response.json())
      .then((data) => {
        if (data && data.insertedId) {
          setSentItems(100);
          setModalStep("done");
          setModalMessageBody("Automatización creada con éxito");
        } else {
          setModalStep("confirm");
          setSentItems(0);
          setModalMessageBody(
            (data && data.error && data.error.message) || "Error al crear la automatización"
          );
        }
      })
      .catch((error) => {
        setModalStep("confirm");
        setSentItems(0);
        setModalMessageBody(`Error al crear la automatización: ${error?.message || error}`);
      });
  };

  const selectTemplate = (e) => {
    const templateID = e.target.value;
    let template = templates.find((template) => template._id == templateID);
    if (!template) return;
    if (!template.buttonparameters) template.buttonparameters = [];
    setSelectedTemplate(template);
    setFilterAutomation((prev) => ({ ...prev, plantilla: template.name }));
  };

  const selectTipoRenovacion = (e) => {
    const tipoRenovacionID = e.target.value;
    if (!tipoRenovacionID) return;
    const found = TipoRenovacionList.find((item) => `${item.id}` === `${tipoRenovacionID}`);
    if (!found) return;
    setSelectedTipoRenovacion(found);
    setFilterAutomation((prev) => ({ ...prev, tipo_renovacion: found.id }));
  };

  const openModal = () => {
    const modal = document.querySelector(".main-modal");
    if (!modal) return;
    modal.classList.remove("fadeOut");
    modal.classList.add("fadeIn");
    modal.style.display = "flex";
  };

  const closeModal = () => {
    const modal = document.querySelector(".main-modal");
    if (!modal) return;
    modal.classList.remove("fadeIn");
    modal.classList.add("fadeOut");
    setTimeout(() => {
      modal.style.display = "none";
    }, 500);
  };

  const handleCheck = (e) => {
    const id = e.target.dataset.id;
    const isChecked = e.target.checked;
    if (isChecked) {
      setCheckedItems([...checkedItems, id]);
    } else {
      setCheckedItems(checkedItems.filter((item) => item != id));
    }
  };

  const checkAll = (e) => {
    const isChecked = e.target.checked;
    const checkboxes = document.querySelectorAll('input[type="checkbox"]');
    let newCheckedItems = [];
    checkboxes.forEach((checkbox) => {
      if (checkbox.checked != isChecked) {
        newCheckedItems.push(checkbox.dataset.id);
        checkbox.checked = isChecked;
      }
    });
    if (!isChecked) {
      setCheckedItems([]);
      return;
    }
    setCheckedItems([...newCheckedItems]);
  };

  const handleSearch = (e) => {
    setSearchTerm(e.target.value || "");
  };

  const resetFilters = () => {
    setPolizasFiltered(polizas);
    const selects = document.querySelectorAll("select");
    selects.forEach((select) => {
      select.selectedIndex = 0;
    });
    setSearchTerm("");
    setActiveFilterColumns([]);
    setColumnFilters({});
    setSelectedVisibleColumns(availableColumns);
    setFilterAutomation({
      filtros: [],
      plantilla: "",
      hora: 0,
      minute: 0,
      dia: 0,
      monthDiff: 0,
      yearDiff: 0,
      month_query: selectedDate.split("-")[1],
      year_query: selectedDate.split("-")[0],
      tipo_renovacion: selectedTipoRenovacion.id,
    });
    setAutomationFilterTipo("");
    setAutomationFilterValor("");
  };

  const generateExcelFromJSON = () => {
    try {
      let allPolizas = [];
      checkedItems.forEach((id) => {
        const poliza = polizas.find((poliza) => poliza._id == id);
        if (!poliza) return;
        allPolizas.push({
          Asegurado: poliza.Asegurado,
          Celular: poliza.Celular,
          Cedula: poliza.Cedula,
          Aseguradora: poliza.Aseguradora,
          Nro_Poliza: poliza.Nro_Poliza,
        });
      });
      const workbook = XLSX.utils.book_new();
      const worksheet = XLSX.utils.json_to_sheet(allPolizas);
      XLSX.utils.book_append_sheet(workbook, worksheet, 'Sheet1');
      const fileName = 'my_excel_file.xlsx';
      XLSX.writeFile(workbook, fileName, { compression: true });
    } catch (error) {
      console.error('Error:', error);
    }
  };

  const [selectedEjecutivo, setSelectedEjecutivo] = useState(null);
  const [ejecutivos, setEjecutivos] = useState([]);

  useEffect(() => {
    if (ejecutivos.length > 0) return;
    async function loadEjecutivos() {
      const baseApi = `${process.env.REACT_APP_BACKEND_API || ""}`.replace(/\/+$/, "");
      const fallbackBase = baseApi.replace(/\/api$/, "");
      const ejecutivoUrls = Array.from(
        new Set([`${baseApi}/ejecutivo`, `${fallbackBase}/api/ejecutivo`])
      );
      const config = {
        headers: {
          "x-access-token": user.accessToken,
          "Content-Type": "application/json",
        },
      };
      let result = null;
      for (const url of ejecutivoUrls) {
        const attempt = await axios.get(url, config).catch(() => null);
        if (attempt?.data) {
          result = attempt;
          break;
        }
      }
      if (result?.data) setEjecutivos(result.data);
    }
    loadEjecutivos();
  }, [ejecutivos, user.accessToken]);

  const handleSelectedEjecutivo = (e) => {
    setSelectedEjecutivo(ejecutivos.find((ejecutivo) => ejecutivo._id === e));
  };

  const toggleVisibleColumn = (column) => {
    setSelectedVisibleColumns((prev) => {
      if (prev.includes(column)) {
        if (prev.length === 1) return prev;
        return prev.filter((item) => item !== column);
      }
      return [...prev, column];
    });
  };

  const selectAllColumns = () => {
    setSelectedVisibleColumns(availableColumns);
  };

  const clearColumnsSelection = () => {
    if (!availableColumns.length) return;
    setSelectedVisibleColumns([availableColumns[0]]);
  };

  const moveVisibleColumn = (column, direction) => {
    setSelectedVisibleColumns((prev) => {
      const index = prev.indexOf(column);
      if (index === -1) return prev;
      const targetIndex = direction === "up" ? index - 1 : index + 1;
      if (targetIndex < 0 || targetIndex >= prev.length) return prev;
      const next = [...prev];
      [next[index], next[targetIndex]] = [next[targetIndex], next[index]];
      return next;
    });
  };

  const formatCellValue = (value) => {
    if (value === null || value === undefined) return "-";
    if (Array.isArray(value)) {
      if (value.length === 0) return "-";
      return value
        .map((item) => {
          if (item && typeof item === "object") {
            if (item.TemplateName) return item.TemplateName;
            return JSON.stringify(item);
          }
          return `${item}`;
        })
        .join(", ");
    }
    if (typeof value === "object") return JSON.stringify(value);
    return `${value}`;
  };

  const getNormalizedValuesForColumn = (rowValue) => {
    if (rowValue === null || rowValue === undefined) return [];
    if (Array.isArray(rowValue)) {
      return rowValue
        .flatMap((item) => {
          if (item && typeof item === "object") {
            if (item.TemplateName) return [`${item.TemplateName}`];
            return Object.values(item).filter((value) => typeof value !== "object").map((value) => `${value}`);
          }
          return [`${item}`];
        })
        .map((value) => value.trim().toLowerCase())
        .filter(Boolean);
    }
    if (typeof rowValue === "object") {
      return Object.values(rowValue)
        .filter((value) => typeof value !== "object")
        .map((value) => `${value}`.trim().toLowerCase())
        .filter(Boolean);
    }
    return [`${rowValue}`.trim().toLowerCase()].filter(Boolean);
  };

  const getUniqueColumnOptions = (column) => {
    if (!column) return [];
    const values = new Set();
    polizas.forEach((poliza) => {
      getNormalizedValuesForColumn(poliza?.[column]).forEach((value) => values.add(value));
    });
    return Array.from(values)
      .sort((a, b) => a.localeCompare(b))
      .map((value) => ({ value, label: value }));
  };

  useEffect(() => {
    setColumnFilters((prev) => {
      const next = { ...prev };
      Object.keys(next).forEach((key) => {
        if (!activeFilterColumns.includes(key)) delete next[key];
      });
      return next;
    });
  }, [activeFilterColumns]);

  useEffect(() => {
    const activeFilters = Object.entries(columnFilters).filter(([, values]) => Array.isArray(values) && values.length > 0);
    const filtered = polizas.filter((poliza) => {
      if (searchTerm.trim()) {
        const normalizedSearch = searchTerm.trim().toLowerCase();
        const rowValues = selectedVisibleColumns
          .flatMap((column) => getNormalizedValuesForColumn(poliza?.[column]));
        if (!rowValues.some((value) => value.includes(normalizedSearch))) return false;
      }

      for (const [column, selectedValues] of activeFilters) {
        const rowValues = getNormalizedValuesForColumn(poliza?.[column]);
        if (!selectedValues.some((value) => rowValues.includes(`${value}`.toLowerCase()))) {
          return false;
        }
      }
      return true;
    });
    setPolizasFiltered(filtered);
  }, [polizas, searchTerm, columnFilters, selectedVisibleColumns]);

  const handleApplyColumnFilter = (column, options) => {
    if (!column) return;
    const values = (options || []).map((option) => option.value);
    setColumnFilters((prev) => ({
      ...prev,
      [column]: values,
    }));
  };

  const clearSingleFilter = (column) => {
    setColumnFilters((prev) => {
      const next = { ...prev };
      delete next[column];
      return next;
    });
  };

  const renderHeaderForColumn = (column) => columnLabelMap[column] || column;

  const renderCellForColumn = (column, poliza) => {
    if (column === "Templates_Sent") {
      return (
        <span className="relative inline-block px-3 py-1 font-semibold text-green-900 leading-tight">
          <span
            aria-hidden
            className={
              "absolute inset-0 opacity-50 rounded-full" +
              (poliza.Templates_Sent && poliza.Templates_Sent.filter((item) => item.TemplateName !== "Pendiente").length > 0
                ? " bg-green-200"
                : " bg-orange-200")
            }
          ></span>
          {poliza.Templates_Sent
            ? poliza.Templates_Sent.map((item, key) => <p key={`${poliza._id}-template-${key}`} className="relative">{item.TemplateName + ""}</p>)
            : "Pendiente"}
        </span>
      );
    }
    if (column === "currentMessageStatus") return poliza.currentMessageStatus ? poliza.currentMessageStatus : "Pendiente";
    if (column === "newMessages") return poliza.currentMessageStatus !== "unsent" && poliza.currentMessageStatus !== "pending" ? poliza.newMessages + " nuevos mensajes" : "Sin respuesta del cliente";
    if (column === "chat") {
      return poliza.currentMessageStatus
        ? <a href={`/dashboard/chat/${poliza.Celular}`} target="_blank" rel="noreferrer" className="text-blue-500 hover:text-blue-700">Ir al chat</a>
        : "No hay chats para esta poliza";
    }
    if (column === "Vencimiento") {
      return new Date(poliza.Vencimiento).getDate() + "/" + (new Date(poliza.Vencimiento).getMonth() + 1) + "/" + new Date(poliza.Vencimiento).getFullYear();
    }
    return formatCellValue(poliza[column]);
  };

  const currentEjecutivoForOverrides = selectedEjecutivo || ejecutivos[0] || null;
  const ejecutivoFieldOptions = currentEjecutivoForOverrides
    ? Object.keys(currentEjecutivoForOverrides).filter(
      (key) => key !== "_id" && key !== "password" && typeof currentEjecutivoForOverrides[key] !== "object"
    )
    : [];

  const previewSamplePoliza =
    polizas.find((item) => item._id == checkedItems[0]) ||
    polizasFiltered[0] ||
    polizas[0];
  const previewResolvedValues = (() => {
    if (!selectedTemplate || !previewSamplePoliza) return [];
    return getParameterValuesForPoliza(selectedTemplate, previewSamplePoliza, variableOverrides);
  })();
  const previewContactAssignment = (() => {
    if (!selectedTemplate || !previewSamplePoliza) return null;
    return buildContactAssignmentPayload(selectedTemplate, previewSamplePoliza, previewResolvedValues)._preview;
  })();
  const previewBodyWithOverrides = (() => {
    if (!previewMessage || !selectedTemplate || !previewSamplePoliza) return "";
    return (selectedTemplate.body || "").replace(/\{\{(\d+)\}\}/g, (_, index) => {
      const value = previewResolvedValues[Number(index) - 1];
      return value ?? `{{${index}}}`;
    });
  })();

  const automationValorOptions = automationFilterTipo
    ? getUniqueColumnOptions(automationFilterTipo)
    : [];

  const addAutomationFilter = () => {
    if (!automationFilterTipo || !automationFilterValor) return;
    const exists = filterAutomation.filtros.some(
      (item) => item.tipo === automationFilterTipo && `${item.valor}` === `${automationFilterValor}`
    );
    if (exists) {
      setAutomationFilterValor("");
      return;
    }
    setFilterAutomation((prev) => ({
      ...prev,
      filtros: [...prev.filtros, { tipo: automationFilterTipo, valor: automationFilterValor }],
    }));
    setAutomationFilterValor("");
  };

  const removeAutomationFilter = (index) => {
    setFilterAutomation((prev) => ({
      ...prev,
      filtros: prev.filtros.filter((_, i) => i !== index),
    }));
  };

  return (
    <>
      <script type="text/javascript" src="https://cdnjs.cloudflare.com/ajax/libs/xlsx/0.13.1/xlsx.full.min.js"></script>
      <div className={`${isDarkMode ? "bg-[#0f1115] text-[#e5e7eb]" : "bg-[#f8fafc] text-gray-800"} h-[calc(100vh-42px)] p-6 rounded-md w-full flex flex-col overflow-hidden`}>
        <div className={`${isDarkMode ? "bg-[#171a21] border-[#2b313d]" : "bg-white border-gray-200"} border rounded-2xl px-6 py-5 shadow-md mb-6`}>
          <div className="flex items-start justify-between gap-4">
            <div className="flex-1">
              <h2 className={`text-2xl font-bold ${isDarkMode ? "text-white" : "text-gray-900"}`}>Automatización de Renovaciones</h2>
              <span className={`text-sm ${isDarkMode ? "text-[#a1a8b5]" : "text-gray-500"}`}>
                {filterAutomation.filtros.length > 0
                  ? "Filtros seleccionados"
                  : "Seleccione filtros y asigne plantillas automatizadas"}
              </span>
              <div className="mt-3 flex flex-wrap gap-2">
                {filterAutomation.filtros.map((filtro, index) => (
                  <span
                    key={`auto-summary-${index}`}
                    className={`${isDarkMode ? "bg-[#222733] text-[#d1d5db] border-[#2b313d]" : "bg-gray-100 text-gray-700 border-gray-300"} inline-flex items-center gap-2 text-xs px-2.5 py-1 rounded-full border`}
                  >
                    {filtro.tipo}: {filtro.valor}
                  </span>
                ))}
                {filterAutomation.plantilla !== "" && (
                  <span className={`${isDarkMode ? "bg-[#1f3358] text-[#bfdbfe] border-[#2b4a82]" : "bg-blue-50 text-blue-700 border-blue-200"} inline-flex items-center gap-2 text-xs px-2.5 py-1 rounded-full border`}>
                    Plantilla: {filterAutomation.plantilla}
                  </span>
                )}
                {filterAutomation.dia !== 0 && (
                  <span className={`${isDarkMode ? "bg-[#222733] text-[#d1d5db] border-[#2b313d]" : "bg-gray-100 text-gray-700 border-gray-300"} inline-flex items-center gap-2 text-xs px-2.5 py-1 rounded-full border`}>
                    Día: {filterAutomation.dia} (o el más cercano lun-vie)
                  </span>
                )}
                {(filterAutomation.hora !== 0 || filterAutomation.minute !== 0) && (
                  <span className={`${isDarkMode ? "bg-[#222733] text-[#d1d5db] border-[#2b313d]" : "bg-gray-100 text-gray-700 border-gray-300"} inline-flex items-center gap-2 text-xs px-2.5 py-1 rounded-full border`}>
                    Hora: {`${String(filterAutomation.hora || 0).padStart(2, "0")}:${String(filterAutomation.minute || 0).padStart(2, "0")}`}
                  </span>
                )}
                {filterAutomation.monthDiff !== 0 && (
                  <span className={`${isDarkMode ? "bg-[#222733] text-[#d1d5db] border-[#2b313d]" : "bg-gray-100 text-gray-700 border-gray-300"} inline-flex items-center gap-2 text-xs px-2.5 py-1 rounded-full border`}>
                    Δ Meses: {filterAutomation.monthDiff}
                  </span>
                )}
                {filterAutomation.yearDiff !== 0 && (
                  <span className={`${isDarkMode ? "bg-[#222733] text-[#d1d5db] border-[#2b313d]" : "bg-gray-100 text-gray-700 border-gray-300"} inline-flex items-center gap-2 text-xs px-2.5 py-1 rounded-full border`}>
                    Δ Años: {filterAutomation.yearDiff}
                  </span>
                )}
              </div>
            </div>
            <button
              type="button"
              onClick={() => setIsDarkMode((prev) => !prev)}
              className={`${isDarkMode ? "bg-[#0f1115] border-[#2b313d] text-[#d1d5db]" : "bg-white border-gray-300 text-gray-700"} inline-flex items-center gap-2 px-3 py-2 rounded-lg border text-sm`}
            >
              <FontAwesomeIcon icon={isDarkMode ? faSun : faMoon} />
              {isDarkMode ? "Light mode" : "Dark mode"}
            </button>
          </div>
        </div>
        <div className={`${isDarkMode ? "bg-[#171a21] border-[#2b313d]" : "bg-white border-gray-200"} border shadow-sm rounded-xl p-4 mb-4`}>
          <div className="flex flex-wrap items-center gap-3">
            <div className={`${isDarkMode ? "bg-[#0f1115] border-[#2b313d]" : "bg-white border-gray-300"} flex items-center p-2 rounded-md border min-w-[240px]`}>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                className={`h-5 w-5 ${isDarkMode ? "text-[#6b7280]" : "text-gray-400"}`}
                viewBox="0 0 20 20"
                fill="currentColor"
              >
                <path
                  fillRule="evenodd"
                  d="M8 4a4 4 0 100 8 4 4 0 000-8zM2 8a6 6 0 1110.89 3.476l4.817 4.817a1 1 0 01-1.414 1.414l-4.816-4.816A6 6 0 012 8z"
                  clipRule="evenodd"
                />
              </svg>
              <input
                onChange={handleSearch}
                value={searchTerm}
                className={`${isDarkMode ? "bg-[#0f1115] text-[#d1d5db]" : "bg-white text-gray-700"} outline-none ml-1 block border-none mr-2 text-sm`}
                type="text"
                placeholder="Buscar..."
              />
            </div>
            <DatePickerCustom
              value={selectedDate}
              onChange={handleDateChange}
            />
            <select
              onChange={handleDayChange}
              className={topControlClassName}
              value={filterAutomation.dia}
            >
              <option value={0}>Día del mes</option>
              {Array.from({ length: 31 }, (_, i) => i + 1).map((day) => (
                <option key={`day-${day}`} value={day}>{day}</option>
              ))}
            </select>
            <input
              type="number"
              min={0}
              max={23}
              value={filterAutomation.hora}
              onChange={handleHourChange}
              className={topControlClassName}
              placeholder="Hora (0-23)"
            />
            <input
              type="number"
              min={0}
              max={59}
              value={filterAutomation.minute}
              onChange={handleMinuteChange}
              className={topControlClassName}
              placeholder="Minuto (0-59)"
            />
            <select onChange={selectTipoRenovacion} className={topControlClassName}>
              <option value="">Tipo Renov.</option>
              {TipoRenovacionList.map((tipoRenovacion) => (
                <option key={tipoRenovacion.id} value={tipoRenovacion.id}>{tipoRenovacion.name}</option>
              ))}
            </select>
            <select onChange={selectTemplate} className={topControlClassName}>
              <option value="">Seleccione plantilla</option>
              {templates.map((template) => (
                <option key={template._id} value={template._id}>{template.name}</option>
              ))}
            </select>
            <select id="selectejecutivo" className={topControlClassName} onChange={(e) => handleSelectedEjecutivo(e.target.value)}>
              <option>Ejecutivo</option>
              {ejecutivos.map((ejecutivo) => (
                <option key={ejecutivo._id} value={ejecutivo._id}>{ejecutivo.firstName} {ejecutivo.lastName}</option>
              ))}
            </select>
            <button
              onClick={() => setColumnsModalOpen(true)}
              className={`${isDarkMode ? "border-[#2b313d] text-[#d1d5db] bg-[#0f1115] hover:bg-[#1f2430]" : "border-gray-300 text-gray-700 bg-white hover:bg-gray-100"} inline-flex items-center gap-2 px-4 py-2 border rounded-lg text-sm font-medium transition`}
            >
              <FontAwesomeIcon icon={faColumns} />
              Columnas ({selectedVisibleColumns.length})
            </button>
            <button
              onClick={prepareCreateAutomation}
              className="inline-block px-6 py-2.5 bg-[#2f6feb] text-white font-medium text-xs leading-tight uppercase rounded-full shadow-md hover:bg-[#3b82f6] transition duration-150 ease-in-out"
            >
              Crear Automatización
            </button>
            <button
              className={`${isDarkMode ? "bg-[#222733] text-[#d1d5db] hover:bg-[#2b313d]" : "bg-gray-100 text-gray-700 hover:bg-gray-200"} inline-block px-6 py-2.5 font-medium text-xs leading-tight uppercase rounded-full shadow-md transition duration-150 ease-in-out`}
              onClick={resetFilters}
            >
              <FontAwesomeIcon icon={faFilter} /> Reset
            </button>
            <button
              onClick={generateExcelFromJSON}
              className={`${isDarkMode ? "bg-[#222733] text-[#d1d5db] hover:bg-[#2b313d]" : "bg-gray-100 text-gray-700 hover:bg-gray-200"} inline-block px-6 py-2.5 font-medium text-xs leading-tight uppercase rounded-full shadow-md transition duration-150 ease-in-out`}
            >
              Export
            </button>
          </div>

          <div className={`${isDarkMode ? "bg-[#0f1115] border-[#2b313d]" : "bg-gray-50 border-gray-200"} mt-4 border rounded-lg p-3`}>
            <div className="flex items-center justify-between mb-2">
              <p className={`text-xs font-semibold uppercase tracking-wide ${isDarkMode ? "text-[#9ca3af]" : "text-gray-600"}`}>
                Filtros de automatización
              </p>
              <span className={`text-xs ${isDarkMode ? "text-[#9ca3af]" : "text-gray-500"}`}>
                {filterAutomation.filtros.length} agregado(s)
              </span>
            </div>
            <div className="flex flex-wrap items-center gap-2">
              <select
                className={topControlClassName}
                value={automationFilterTipo}
                onChange={(e) => {
                  setAutomationFilterTipo(e.target.value);
                  setAutomationFilterValor("");
                }}
              >
                <option value="">Tipo de filtro</option>
                {automationFilterTipoOptions.map((option) => (
                  <option key={option.value} value={option.value}>{option.label}</option>
                ))}
              </select>
              <select
                className={topControlClassName}
                value={automationFilterValor}
                onChange={(e) => setAutomationFilterValor(e.target.value)}
                disabled={!automationFilterTipo}
              >
                <option value="">Valor</option>
                {automationValorOptions.map((option) => (
                  <option key={`${automationFilterTipo}-${option.value}`} value={option.value}>{option.label}</option>
                ))}
              </select>
              <button
                type="button"
                onClick={addAutomationFilter}
                disabled={!automationFilterTipo || !automationFilterValor}
                className={`inline-flex items-center gap-2 px-4 py-2 rounded-lg text-sm font-medium transition ${
                  !automationFilterTipo || !automationFilterValor
                    ? (isDarkMode ? "bg-[#1a1f29] text-[#4b5563] cursor-not-allowed" : "bg-gray-100 text-gray-400 cursor-not-allowed")
                    : "bg-[#2f6feb] text-white hover:bg-[#3b82f6]"
                }`}
              >
                <FontAwesomeIcon icon={faPlus} />
                Agregar
              </button>
            </div>
            {filterAutomation.filtros.length > 0 && (
              <div className="mt-3 flex flex-wrap gap-2">
                {filterAutomation.filtros.map((filtro, index) => (
                  <span
                    key={`auto-filter-${index}`}
                    className={`${isDarkMode ? "bg-[#222733] text-[#d1d5db] border-[#2b313d]" : "bg-white text-gray-700 border-gray-300"} inline-flex items-center gap-2 text-xs px-2.5 py-1 rounded-full border`}
                  >
                    {filtro.tipo}: {filtro.valor}
                    <button
                      type="button"
                      onClick={() => removeAutomationFilter(index)}
                      className={`${isDarkMode ? "text-[#9ca3af] hover:text-white" : "text-gray-500 hover:text-gray-800"}`}
                    >
                      <FontAwesomeIcon icon={faTimes} />
                    </button>
                  </span>
                ))}
              </div>
            )}
          </div>

          <div className="mt-4">
            <ReactSelect
              isMulti
              options={availableColumns.map((column) => ({
                value: column,
                label: columnLabelMap[column] || column,
              }))}
              value={activeFilterColumns.map((column) => ({
                value: column,
                label: columnLabelMap[column] || column,
              }))}
              onChange={(options) => setActiveFilterColumns((options || []).map((opt) => opt.value))}
              closeMenuOnSelect={false}
              styles={reactSelectFilterStyles}
              placeholder="Selecciona columnas para filtrar la tabla..."
            />
          </div>
          {activeFilterColumns.length > 0 && (
            <div className="mt-3 grid grid-cols-1 md:grid-cols-2 gap-2">
              {activeFilterColumns.map((column) => (
                <div key={`filter-values-${column}`} className="grid grid-cols-[1fr_auto] gap-2">
                  <ReactSelect
                    isMulti
                    options={getUniqueColumnOptions(column)}
                    value={(columnFilters[column] || []).map((value) => ({ value, label: value }))}
                    onChange={(options) => handleApplyColumnFilter(column, options)}
                    closeMenuOnSelect={false}
                    styles={reactSelectFilterStyles}
                    placeholder={`Valores: ${columnLabelMap[column] || column}`}
                  />
                  <button
                    type="button"
                    onClick={() => clearSingleFilter(column)}
                    className={`${isDarkMode ? "bg-[#222733] text-[#d1d5db] border-[#2b313d] hover:bg-[#2b313d]" : "bg-gray-100 text-gray-700 border-gray-300 hover:bg-gray-200"} px-3 py-2 text-xs rounded-md border`}
                  >
                    Limpiar
                  </button>
                </div>
              ))}
            </div>
          )}
          {Object.entries(columnFilters).some(([, values]) => values?.length) && (
            <div className="mt-3 flex flex-wrap gap-2">
              {Object.entries(columnFilters)
                .filter(([, values]) => values?.length)
                .map(([column, values]) => (
                  <span
                    key={`chip-${column}`}
                    className={`${isDarkMode ? "bg-[#222733] text-[#d1d5db] border-[#2b313d]" : "bg-gray-100 text-gray-700 border-gray-300"} inline-flex items-center gap-2 text-xs px-2.5 py-1 rounded-full border`}
                  >
                    {(columnLabelMap[column] || column) + `: ${values.length}`}
                    <button type="button" onClick={() => clearSingleFilter(column)} className={`${isDarkMode ? "text-[#9ca3af] hover:text-white" : "text-gray-500 hover:text-gray-800"}`}>
                      <FontAwesomeIcon icon={faTimes} />
                    </button>
                  </span>
                ))}
            </div>
          )}
        </div>
        <div className="flex flex-col mt-5 min-h-0 flex-1">
          <div className="w-full min-h-0 flex-1">
            <div className={`${isDarkMode ? "border-[#2b313d] bg-[#171a21]" : "border-gray-200 bg-white"} minimal-horizontal-scroll h-full overflow-auto rounded-lg border`}>
              <div className="min-w-max min-h-full">
                <table className="w-full min-w-max">
                  <thead className={`${isDarkMode ? "border-[#2b313d]" : "border-gray-200"} border-b`}>
                    <tr>
                      <th
                        scope="col"
                        className={`${isDarkMode ? "text-[#9ca3af] bg-[#1f2430]" : "text-gray-500 bg-gray-50"} text-xs tracking-wide uppercase font-medium px-4 py-3 text-left`}
                      >
                        #
                      </th>
                      <th
                        scope="col"
                        className={`${isDarkMode ? "text-[#9ca3af] bg-[#1f2430]" : "text-gray-500 bg-gray-50"} text-xs tracking-wide uppercase font-medium px-4 py-3 text-left`}
                      >
                        <input type="checkbox" onChange={checkAll} />
                      </th>
                      {selectedVisibleColumns.map((column) => (
                        <th
                          key={`header-${column}`}
                          scope="col"
                          className={`${isDarkMode ? "text-[#9ca3af] bg-[#1f2430]" : "text-gray-500 bg-gray-50"} text-xs tracking-wide uppercase font-medium px-4 py-3 text-left`}
                        >
                          {renderHeaderForColumn(column)}
                        </th>
                      ))}
                    </tr>
                  </thead>
                  <tbody>
                    {polizasFiltered.length > 0 ? (
                      polizasFiltered.map((poliza, index) => (
                        <tr key={`row-${poliza._id || index}`} className={`${isDarkMode ? "border-[#2b313d] hover:bg-[#1b2029]" : "border-gray-200 hover:bg-gray-50"} border-b`}>
                          <td className={`${isDarkMode ? "text-[#e5e7eb]" : "text-gray-900"} px-4 py-3 whitespace-nowrap text-sm font-medium`}>
                            {index + 1}
                          </td>
                          <td className={`${isDarkMode ? "text-[#cbd5e1]" : "text-gray-700"} text-sm font-light px-4 py-3 whitespace-nowrap`}>
                            <input
                              type="checkbox"
                              data-id={poliza._id}
                              key={index}
                              onChange={handleCheck}
                            />
                          </td>
                          {selectedVisibleColumns.map((column) => (
                            <td
                              key={`cell-${poliza._id}-${column}`}
                              className={`${isDarkMode ? "text-[#cbd5e1]" : "text-gray-700"} text-sm font-light px-4 py-3 whitespace-nowrap`}
                            >
                              {renderCellForColumn(column, poliza)}
                            </td>
                          ))}
                        </tr>
                      ))
                    ) : (
                      <tr>
                        <td colSpan={selectedVisibleColumns.length + 2} className={`${isDarkMode ? "text-[#9ca3af]" : "text-gray-500"} text-center py-6`}>
                          <FontAwesomeIcon icon={faSpinner} spinPulse />
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>

      {columnsModalOpen && (
        <div className="fixed inset-0 z-50 flex items-center justify-center backdrop-blur-sm bg-black/30">
          <div className="bg-white w-11/12 md:max-w-xl rounded-xl border border-gray-200 shadow-xl">
            <div className="px-5 py-4 border-b border-gray-100 flex items-center justify-between">
              <h3 className="text-lg font-semibold text-gray-800">Columnas visibles</h3>
              <button
                onClick={() => setColumnsModalOpen(false)}
                className="text-gray-500 hover:text-gray-700"
              >
                ✕
              </button>
            </div>
            <div className="px-5 py-4">
              <p className="text-sm text-gray-500 mb-3">
                Las columnas se cargan automaticamente desde los datos obtenidos en polizas.
              </p>
              <div className="flex gap-2 mb-3">
                <button
                  type="button"
                  onClick={selectAllColumns}
                  className="px-3 py-1.5 text-xs font-medium rounded-md border border-gray-300 bg-white text-gray-700 hover:bg-gray-50"
                >
                  Seleccionar todas
                </button>
                <button
                  type="button"
                  onClick={clearColumnsSelection}
                  className="px-3 py-1.5 text-xs font-medium rounded-md border border-gray-300 bg-white text-gray-700 hover:bg-gray-50"
                >
                  Limpiar
                </button>
              </div>
              <div className="mb-4">
                <p className="text-xs font-semibold text-gray-600 mb-2">Orden de columnas visibles</p>
                <div className="max-h-40 overflow-y-auto border border-gray-100 rounded-md p-2 space-y-2 bg-gray-50">
                  {selectedVisibleColumns.map((column, index) => (
                    <div key={`selected-order-${column}`} className="flex items-center justify-between bg-white border border-gray-100 rounded-md px-2 py-1.5">
                      <span className="text-sm text-gray-700">{columnLabelMap[column] || column}</span>
                      <div className="flex items-center gap-1">
                        <button
                          type="button"
                          onClick={() => moveVisibleColumn(column, "up")}
                          disabled={index === 0}
                          className="px-2 py-0.5 text-xs border border-gray-200 rounded disabled:opacity-40"
                        >
                          ↑
                        </button>
                        <button
                          type="button"
                          onClick={() => moveVisibleColumn(column, "down")}
                          disabled={index === selectedVisibleColumns.length - 1}
                          className="px-2 py-0.5 text-xs border border-gray-200 rounded disabled:opacity-40"
                        >
                          ↓
                        </button>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
              <div className="max-h-80 overflow-y-auto grid grid-cols-1 sm:grid-cols-2 gap-2">
                {availableColumns.map((column) => (
                  <label
                    key={column}
                    className="flex items-center gap-2 p-2 rounded-md border border-gray-100 hover:bg-gray-50"
                  >
                    <input
                      type="checkbox"
                      checked={selectedVisibleColumns.includes(column)}
                      onChange={() => toggleVisibleColumn(column)}
                    />
                    <span className="text-sm text-gray-700">
                      {columnLabelMap[column] || column}
                    </span>
                  </label>
                ))}
              </div>
            </div>
            <div className="px-5 py-3 border-t border-gray-100 flex justify-end">
              <button
                onClick={() => setColumnsModalOpen(false)}
                className="px-4 py-2 bg-indigo-600 text-white rounded-md hover:bg-indigo-500"
              >
                Aplicar
              </button>
            </div>
          </div>
        </div>
      )}

      <div
        style={{ display: "none" }}
        className="main-modal fixed w-full h-100 inset-0 z-50 overflow-hidden flex justify-center items-center animated fadeIn faster backdrop-blur-sm bg-black/30"
      >
        <div className="border border-gray-200 rounded-lg shadow-lg modal-container bg-white w-[96vw] max-w-6xl max-h-[92vh] mx-auto z-50 overflow-y-auto">
          <div className="modal-content py-4 text-left px-6">
            <div className="flex justify-between items-center pb-3">
              <p className="text-2xl font-bold">
                {modalStep === "confirm"
                  ? "Crear Automatización"
                  : modalStep === "sending"
                    ? "Creando automatización..."
                    : "Automatización creada"}
              </p>
              <div
                className="modal-close cursor-pointer z-50"
                onClick={closeModal}
              >
                <svg
                  className="fill-current text-black"
                  xmlns="http://www.w3.org/2000/svg"
                  width="18"
                  height="18"
                  viewBox="0 0 18 18"
                >
                  <path d="M14.53 4.53l-1.06-1.06L9 7.94 4.53 3.47 3.47 4.53 7.94 9l-4.47 4.47 1.06 1.06L9 10.06l4.47 4.47 1.06-1.06L10.06 9z"></path>
                </svg>
              </div>
            </div>
            <div className="my-5">
              {modalStep === "confirm" && previewMessage && (
                <div>
                  <p className="text-sm text-gray-600 mb-3">
                    Vista previa de la automatización. Cuando se ejecute enviará este mensaje a las pólizas que cumplan los filtros configurados.
                  </p>
                  <div className="grid grid-cols-1 lg:grid-cols-[1.2fr_1fr] gap-4">
                    <div>
                      <div className="mb-4 border rounded-lg p-3 bg-gray-50 max-h-72 overflow-y-auto">
                        <p className="text-xs text-gray-500 mb-2">
                          Variables del template (valor fijo opcional para esta automatización):
                        </p>
                        {Array.from({ length: getTemplateVariableCount(selectedTemplate) }, (_, i) => i + 1).map((varIndex) => (
                          <div key={varIndex} className="grid grid-cols-12 gap-2 items-center mb-2">
                            <div className="col-span-2 text-xs font-semibold">{`{{${varIndex}}}`}</div>
                            <input
                              className="col-span-6 border rounded px-2 py-1 text-sm"
                              placeholder="Valor fijo (opcional)"
                              value={variableOverrides[varIndex] ?? ""}
                              onChange={(event) =>
                                setVariableOverrides((prev) => ({
                                  ...prev,
                                  [varIndex]: event.target.value,
                                }))
                              }
                            />
                            <select
                              className="col-span-4 border rounded px-2 py-1 text-xs"
                              value=""
                              onChange={(event) => {
                                const selectedField = event.target.value;
                                if (!selectedField || !currentEjecutivoForOverrides) return;
                                setVariableOverrides((prev) => ({
                                  ...prev,
                                  [varIndex]: `${currentEjecutivoForOverrides[selectedField] ?? ""}`,
                                }));
                              }}
                            >
                              <option value="">Dato ejecutivo</option>
                              {ejecutivoFieldOptions.map((field) => (
                                <option key={field} value={field}>
                                  {field}
                                </option>
                              ))}
                            </select>
                          </div>
                        ))}
                      </div>
                      <div className="border rounded-lg p-3 bg-gray-50 mb-4">
                        <p className="text-xs text-gray-500 mb-2">Prueba individual</p>
                        <div className="flex gap-2">
                          <input
                            className="flex-1 border rounded px-3 py-2 text-sm"
                            placeholder="Numero de telefono para prueba"
                            value={customTestPhone}
                            onChange={(event) => setCustomTestPhone(event.target.value)}
                          />
                          <button
                            type="button"
                            onClick={sendTestTemplateMessage}
                            className="px-3 py-2 bg-blue-600 text-white text-sm rounded hover:bg-blue-500"
                          >
                            Enviar prueba
                          </button>
                        </div>
                        {testSendStatus && (
                          <p className="text-xs text-gray-600 mt-2">{testSendStatus}</p>
                        )}
                      </div>
                      <div className="border rounded-lg p-3 bg-gray-50">
                        <p className="text-xs text-gray-500 mb-2 font-semibold uppercase tracking-wide">Resumen de automatización</p>
                        <ul className="text-xs text-gray-700 space-y-1">
                          <li><span className="font-semibold">Plantilla:</span> {filterAutomation.plantilla || "-"}</li>
                          <li><span className="font-semibold">Hora:</span> {String(filterAutomation.hora || 0).padStart(2, "0")}</li>
                          <li><span className="font-semibold">Minuto:</span> {String(filterAutomation.minute || 0).padStart(2, "0")}</li>
                          <li><span className="font-semibold">Día del mes:</span> {filterAutomation.dia || "-"}</li>
                          <li><span className="font-semibold">Δ Meses:</span> {filterAutomation.monthDiff}</li>
                          <li><span className="font-semibold">Δ Años:</span> {filterAutomation.yearDiff}</li>
                          <li><span className="font-semibold">Tipo Renovación:</span> {selectedTipoRenovacion.name}</li>
                          <li>
                            <span className="font-semibold">Filtros:</span>{" "}
                            {filterAutomation.filtros.length === 0
                              ? "ninguno"
                              : filterAutomation.filtros.map((f, i) => (
                                <span key={`resumen-${i}`} className="inline-block bg-white border border-gray-200 rounded-full px-2 py-0.5 mr-1 mb-1">
                                  {f.tipo}: {f.valor}
                                </span>
                              ))}
                          </li>
                        </ul>
                        {modalMessageBody && (
                          <p className="text-xs text-red-600 mt-2">{modalMessageBody}</p>
                        )}
                      </div>
                    </div>
                    <div className="flex justify-center">
                      <div className="w-[320px] h-[600px] rounded-[2rem] border-[6px] border-slate-800 bg-slate-900 overflow-hidden shadow-lg">
                        <div className="h-full bg-[#E5DDD5] flex flex-col">
                          <div className="bg-[#075E54] text-white px-3 py-2 text-sm font-semibold">
                            {previewMessage.asegurado || "Cliente"}
                          </div>
                          <div className="p-2 flex-1 overflow-y-auto">
                            <div className="bg-white rounded-lg rounded-tl-none shadow-sm overflow-hidden">
                              {previewMessage.image && (
                                <div className="w-full aspect-[1.91/1] bg-slate-100">
                                  <img
                                    src={previewMessage.image}
                                    alt="Preview"
                                    className="w-full h-full object-cover"
                                  />
                                </div>
                              )}
                              <div className="p-3">
                                <p className="text-[13px] leading-relaxed whitespace-pre-wrap break-words">
                                  {previewBodyWithOverrides || previewMessage.body || "Sin contenido"}
                                </p>
                                <div className="mt-2 border-t border-dashed border-slate-200 pt-2 text-[11px] text-slate-600">
                                  <p>Asignacion contacto:</p>
                                  <p>Nombre cliente: {previewContactAssignment?.nombreCliente || "-"}</p>
                                  <p>Ejecutivo nombre: {previewContactAssignment?.ejecutivoName || "-"}</p>
                                  <p>Campo id ejecutivo: {previewContactAssignment?.ejecutivoIdField || "-"}</p>
                                  <p>Fallback ejecutivo: {previewContactAssignment?.fallbackEjecutivoId || "-"}</p>
                                  <p>Ejecutivo id: {previewContactAssignment?.ejecutivoId || "-"}</p>
                                </div>
                                <div className="flex justify-end text-[10px] text-slate-400 mt-1">
                                  ahora
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              )}
              {modalStep !== "confirm" && (
                <div>
                  <p>{modalMessageBody}</p>
                  <div className="w-full bg-gray-200 h-1 rounded-lg mt-5">
                    <div
                      className="bg-blue-600 h-3 rounded-lg"
                      style={{ width: sentItems + "%" }}
                    ></div>
                  </div>
                </div>
              )}
            </div>
            <div className="flex justify-end pt-2">
              <button
                onClick={closeModal}
                className="focus:outline-none modal-close px-4 bg-gray-400 p-3 rounded-lg text-white hover:bg-gray-300"
              >
                {modalStep === "confirm" ? "Cancelar" : "Cerrar"}
              </button>
              {modalStep === "confirm" && (
                <button
                  onClick={confirmCreateAutomation}
                  className="focus:outline-none px-4 bg-teal-500 p-3 ml-3 rounded-lg text-white hover:bg-teal-400"
                >
                  Confirmar creación
                </button>
              )}
              {modalStep === "sending" && (
                <button
                  disabled
                  className="focus:outline-none px-4 bg-slate-300 p-3 ml-3 rounded-lg text-white"
                >
                  Creando...
                </button>
              )}
              {modalStep === "done" && (
                <button
                  onClick={closeModal}
                  className="focus:outline-none px-4 bg-teal-500 p-3 ml-3 rounded-lg text-white hover:bg-teal-400"
                >
                  Listo
                </button>
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
